// src/components/ChatRequestPopup.js
import React, { useEffect, useState } from 'react';
// import { useChatRequests } from '@/contexts/ChatRequestContext';
import { CheckCircle, XCircle, Clock } from 'lucide-react';
import { useChatRequests } from '@/context/ChatRequestsContext';

export default function ChatRequestPopup() {
    const { activeRequest, showNotification, acceptChatRequest, declineChatRequest, closeNotification } = useChatRequests();
    const [timeRemaining, setTimeRemaining] = useState({ minutes: 2, seconds: 0 });

    // Update countdown timer
    useEffect(() => {
        if (!activeRequest) return;

        const expiresAt = new Date(activeRequest.expiresAt);

        const timerInterval = setInterval(() => {
            const now = new Date();
            const diffMs = expiresAt - now;

            if (diffMs <= 0) {
                clearInterval(timerInterval);
                declineChatRequest(activeRequest.chatId, "Request timed out");
                return;
            }

            const minutes = Math.floor(diffMs / (1000 * 60));
            const seconds = Math.floor((diffMs % (1000 * 60)) / 1000);

            setTimeRemaining({ minutes, seconds });
        }, 1000);

        return () => clearInterval(timerInterval);
    }, [activeRequest, declineChatRequest]);

    if (!showNotification || !activeRequest) return null;

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="bg-white rounded-lg shadow-lg p-6 max-w-md w-full mx-4 animate-fade-in-up">
                <div className="flex justify-between items-start mb-4">
                    <h3 className="text-lg font-semibold text-primary">New Chat Request</h3>
                    <div className="flex items-center text-sm bg-orange-100 text-orange-600 px-2 py-1 rounded-full">
                        <Clock className="w-3 h-3 mr-1" />
                        <span>
                            {String(timeRemaining.minutes).padStart(2, '0')}:{String(timeRemaining.seconds).padStart(2, '0')}
                        </span>
                    </div>
                </div>

                <div className="flex items-center gap-4 mb-6">
                    <div className="w-16 h-16 rounded-full bg-orange-100 flex items-center justify-center overflow-hidden">
                        {activeRequest.userPicture && activeRequest.userPicture !== "/" ? (
                            <img
                                src={activeRequest.userPicture}
                                alt={activeRequest.userName}
                                className="w-full h-full object-cover"
                            />
                        ) : (
                            <span className="text-orange-600 text-2xl font-bold">
                                {activeRequest.userName?.charAt(0)?.toUpperCase() || "U"}
                            </span>
                        )}
                    </div>
                    <div>
                        <h4 className="font-medium text-lg">{activeRequest.userName || "User"}</h4>
                        <p className="text-gray-600 text-sm">wants to start a chat session with you</p>
                    </div>
                </div>

                <div className="flex gap-3 justify-end">
                    <button
                        onClick={() => declineChatRequest(activeRequest.chatId)}
                        className="px-4 py-2 bg-gray-100 text-gray-700 rounded-md hover:bg-gray-200 transition flex items-center"
                    >
                        <XCircle className="w-4 h-4 mr-1" />
                        Decline
                    </button>

                    <button
                        onClick={() => acceptChatRequest(activeRequest.chatId)}
                        className="px-4 py-2 bg-primary text-white rounded-md hover:bg-primary/90 transition flex items-center"
                    >
                        <CheckCircle className="w-4 h-4 mr-1" />
                        Accept
                    </button>
                </div>
            </div>
        </div>
    );
}